export const PowerECRSourceDescription = () => (
  <div className="flex flex-col gap-y-4">
    Entries from the Embedded Capacity Register are separated here by broad technology type.
  </div>
);
